

import {Request} from '@/api/request';
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch, nextTick,
} from "vue";
import {
    getInfoOrderOffer,
    getLibraryInfo, getMountingsCheckOutInfo,
    getOrderCarMountings,
    getOrderCarProject,
    postAddOrderOffer
} from "@/api/http";
import {dateformat} from "@/api/date" ;
import {column} from "@/assets/types/common";
import editList from "@/components/editlist/editlist.vue";
import {useRoute, useRouter} from 'vue-router'
import {validateInput, validateClass} from "@/assets/js/formRules";

type project = {
  id: number;
  project_type_pid: number;
  name: string;
};
type dialogSelect = {
  project_type_pid?: number;
  search?: string;
};
type order = {
  basicset_id: number;
  id: number;
  user_id: number;
  coupon_text: string;
  pay_type: number;
  payment: number;
  order: any;
  order_car: any;
  order_message: any;
  offer: any;
  last_order_id: string;
  next_order_id: string
};
const carcodeColumn: Array<column> = [
  {
    prop: "ordersn",
    label: "单据编号",
    width: 84,
  },
  {
    prop: "car_code",
    label: "车牌号",
    width: 84,
  },

  {
    prop: "category_name",
    label: "车辆型号",
    width: 84,
  },
  {
    prop: "meet_vehicle",
    label: "接车人",
    width: 84,
  },
  {
    prop: "create_time_text",
    label: "开单时间",
    width: 84,
  },
];
const partsColumn: Array<column> = [
  {
    prop: "name",
    label: "配件名称",
    width: 84,
  },

  {
    prop: "specification",
    label: "规格",
    width: 84,
  },
  {
    prop: "mountings_type_name",
    label: "配件分类",
    width: 84,
  },
  {
    prop: "mountings_brand_name",
    label: "品牌",
    width: 84,
  },
  {
    prop: "mountings_unit_name",
    label: "单位",
    width: 84,
  },
  {
    prop: "price",
    label: "价格",
    width: 84,
  },
  {
    prop: "stock",
    label: "库存",
    width: 84,
  },
];
const detailColumn: Array<column> = [
  {
    prop: "name",
    label: "配件名称",
    width: 84,
  },
  {
    prop: "mountings_name",
    label: "编码",
    width: 84,
  },

  {
    prop: "specification",
    label: "规格",
    width: 84,
  },
  {
    prop: "mountings_type_name",
    label: "分类",
    width: 84,
  },
  {
    prop: "mountings_brand_name",
    label: "品牌",
    width: 84,
  },
  {
    prop: "mountings_unit_name",
    label: "品牌",
    width: 84,
  },
  {
    prop: "price",
    label: "单位",
    width: 84,
  },
  {
    prop: "stock",
    label: "报价数量",
    width: 84,
  },
  {
    prop: "stock",
    label: "用料数量",
    width: 84,
  },
  {
    prop: "stock",
    label: "领料",
    width: 84,
  },
  {
    prop: "stock",
    label: "退料",
    width: 84,
  },
];

const coloumList = [
  [
    {
      type: 'lable',
      field: 'name',
      label: '配件名称',
      title: '',
      img: {
        src: '',
        width: 0,
        height: 0
      },
      width: 450,
      ewidth: '',
      estyle: '',
      eclass: ''
    },
    {
      type: 'lable',
      field: 'mountings_type_p_name',
      label: '配件分类',
      title: '',
      img: {
        src: '',
        width: 0,
        height: 0
      },
      width: 120,
      ewidth: '',
      estyle: '',
      eclass: ''
    },
    {
      type: 'lable',
      field: 'mountings_unit_name',
      label: '单位',
      title: '',
      img: {
        src: '',
        width: 0,
        height: 0
      },
      width: 120,
      ewidth: '',
      estyle: '',
      eclass: ''
    },
    {
      type: 'lable',
      field: 'cost_price',
      label: '采购单价',
      title: '',
      img: {
        src: '',
        width: 0,
        height: 0
      },
      width: 120,
      ewidth: '',
      estyle: '',
      eclass: ''
    },
    {
      type: 'lable',
      field: 'member',
      label: '数量',
      title: '',
      img: {
        src: '',
        width: 0,
        height: 0
      },
      width: '',
      ewidth: '',
      estyle: '',
      eclass: ''
    },
    {
      type: 'lable',
      field: 'stock_number_',
      label: '已入库',
      title: '',
      img: {
        src: '',
        width: 0,
        height: 0
      },
      width: 125,
      ewidth: '',
      estyle: '',
      eclass: ''
    },
    {
      type: 'lable',
      field: 'stay_number',
      label: '待入库',
      title: '',
      img: {
        src: '',
        width: 0,
        height: 0
      },
      width: 125,
      ewidth: '',
      estyle: '',
      eclass: ''
    },
    {
      type: 'input',
      field: 'stock_number',
      label: '退料',
      title: '',
      img: {
        src: '',
        width: 0,
        height: 0
      },
      width: 125,
      ewidth: 80,
      estyle: '',
      eclass: ''
    },
    {
      type: 'lable',
      field: 'return_number',
      label: '退货数量',
      title: '',
      img: {
        src: '',
        width: 0,
        height: 0
      },
      width: 125,
      ewidth: 80,
      estyle: '',
      eclass: ''
    },
  ],
  [
    {
      type: 'button',
      field: 'name',
      label: '配件名称',
      title: '',
      img: {
        src: '',
        width: 0,
        height: 0
      },
      width: 450,
      ewidth: 355,
      estyle: '',
      eclass: ''
    },
    {
      type: 'specification',
      field: 'mountings_type_p_name',
      label: '编码',
      title: '',
      img: {
        src: '',
        width: 0,
        height: 0
      },
      width: 120,
      ewidth: '',
      estyle: '',
      eclass: ''
    },
    {
      type: 'lable',
      field: 'mountings_type_pname',
      label: '规格',
      title: '',
      img: {
        src: '',
        width: 0,
        height: 0
      },
      width: 120,
      ewidth: '',
      estyle: '',
      eclass: ''
    },
    {
      type: '分类',
      field: 'mountings_type_pname',
      label: '采购单价',
      title: '',
      img: {
        src: '',
        width: 0,
        height: 0
      },
      width: 120,
      ewidth: '',
      estyle: '',
      eclass: ''
    },
    {
      type: 'lable',
      field: 'mountings_brand_name',
      label: '品牌',
      title: '',
      img: {
        src: '',
        width: 0,
        height: 0
      },
      width: '',
      ewidth: '',
      estyle: '',
      eclass: ''
    },
    {
      type: 'lable',
      field: 'unit',
      label: '单位',
      title: '',
      img: {
        src: '',
        width: 0,
        height: 0
      },
      width: 125,
      ewidth: '',
      estyle: '',
      eclass: ''
    },
    {
      type: 'lable',
      field: 'number',
      label: '退料',
      title: '',
      img: {
        src: '',
        width: 0,
        height: 0
      },
      width: 125,
      ewidth: 80,
      estyle: '',
      eclass: ''
    },
  ]

]
const return_cash_plan = {
  return_cash_plan: [
    {
      required: true,
      validator: (rule: any, value: string, callback: Function) => {
        if (value) {
          callback();
        } else {
          callback(new Error("请选择返现方案"));
        }
      },
      trigger: "blur",
    },
  ],
};
const partsRules = {
  name: [
    {
      required: true,
      validator: (rule: any, value: string, callback: Function) => {
        validateInput("请输入配件名称", value, callback);
      },
      trigger: "change",
    },
  ],
  price: [
    {
      required: true,
      validator: (rule: any, value: string, callback: Function) => {
        validateInput("请输入销售价", value, callback);
      },
      trigger: "change",
    },
  ],
  specification: [
    {
      required: true,
      validator: (rule: any, value: string, callback: Function) => {
        validateInput("请输入规格", value, callback);
      },
      trigger: "change",
    },
  ],
  encoding: [
    {
      required: true,
      validator: (rule: any, value: string, callback: Function) => {
        validateInput("请输入编码", value, callback);
      },
      trigger: "change",
    },
  ],
  unit_id: [
    {
      required: true,
      validator: (rule: any, value: string, callback: Function) => {
        if (value) {
          callback();
        } else {
          callback(new Error("请选择单位"));
        }
      },
      trigger: "blur",
    },
  ],
  ...return_cash_plan,
};

const formRules = {
  type: [{required: true, message: '必填', trigger: 'change'}],
  supplier_id: [{required: true, message: '必填', trigger: 'change'}],
  date: [{required: true, message: '必填', trigger: 'change'}],
}


export default defineComponent({
  name: "warehouselicreate",
  components: {editList},
  setup() {
    const setTitle: any = inject("setTitle");
    const headClass = inject("headClass");
    const Router = useRouter();
    let searchKeyWords = ref(''),
        //配件搜索
        searchMountings = ()=>{
            getOrderCarMountings({search:searchKeyWords.value}).then((res: any) => {
                partsTable.value = res?.content?.mountings_data?.list || [];
            });
        };
    let navindex = ref(0),
        uid: any = 0,
        inputref = ref(null) as any,
        type: any = '',
        offer_data = ref([]) as any,
        dialog_show = reactive({
          parts: false,
          carcode: false
        } as any),
        is_save = ref(false),
        dialog_show_ = ref(""),
        dialogNavIndex = ref(0),
        dialog_search = ref('' as string),
        dialog_isload = ref(false),
        dialog_data = ref([] as Array<any>),
        detailData = reactive([1, 2, 4, 5, 6] as Array<any>),
        serviceForm = ref({
          name: "",
          price: null,
          return_cash_plan: null,
        }),
        partsForm = ref({
          ...serviceForm.value,
          encoding: null,
          specification: "",
          unit_id: null,
        }),
        is_detail = ref(false),
        partsFormNode = ref(null),
        partsTable = ref([]),
        dialogSelect = ref({} as dialogSelect),
        serviceTable = ref([]),
        form = ref({
          type: 0,
          takeaway: null,
          car_order_id: null,
          car_name: null,
          parts: [],
          branch_id: null,
          ordersn: null,
          desc: ""
        } as any),
        is_all = ref(false),
        serviceDialog = ref(false),
        supplierList = ref([] as any),
        orderDetail = ref({offer: [[], []]} as order),
        selectData: Array<project> = [],
        selectList = reactive({
          staff: [],
          branch: [],
          mountings_type_data: [],
          mountings_type_p_data: []
        }),
        is_load = ref(false),
        formRef = ref(null),
        PurchaseManList = ref([] as any),
        getOrderMountings = (): void => {
          getOrderCarMountings(dialogSelect.value).then((res: any) => {

            // partsTable.value = res?.content?.mountings_data?.list || [];
            // select.mountings_type_data = res?.content?.mountings_type || [];
            // select.mountings_type_p_data =  res?.content?.mountings_type_p || [];
          });
        },
        handleSelectionChange = (selection: Array<project>): void => {
          selectData = selection;
        },
        //选中配件列表的一条数据
        handleCurrentChange = (selection: any): void => {
          if (!selection) return
            for (const parts of form.value.parts) {
                if (parts.mountings_id == selection.id) {
                    alert("您选择的配件已经在列表中了，请直接改数量");
                    return;
                }
            }
          form.value.parts.push({
            mountings_type_id: selection.id,
            mountings_id: selection.id,
            name: selection.name,
            specification: selection.specification,
            mountings_type_pname: selection.mountings_type_name,
            mountings_brand_name: selection.mountings_brand_name,
            unit: selection.mountings_unit_name,
            unit_price: selection.price,
            number: '0'
          })
          dialog_show_.value = ''

        },
        dialogSelectChange = (
            value: string | number,
            key: keyof dialogSelect
        ): void => {
          if (!value) {
            delete dialogSelect.value[key];
          }
          if (serviceDialog.value) {
            getOrderProject();
          } else {
            getOrderMountings();
          }
        },
        getOrderProject = (): void => {
          getOrderCarProject(dialogSelect.value).then((res: any) => {
            // serviceTable.value = res?.content?.project?.list || [];
            // select.project_type_data =
            //     res?.content?.project_type?.list || [];
          });
        },
        checkFormData = (): boolean => {
          if (navindex.value == 1) {//入库
            if (form.value.type == 0) {
              if (!form.value.takeaway) {
                alert('请选择退料人');
                return false;
              }
              if (!form.value.car_name) {
                alert('请选择维修车辆')
                return false;
              }
              if (!form.value.branch_id) {
                alert('请选择成本承担部门')
                return false;
              }
            } else if (form.value.type == 1) {
              if (form.value.type == 1) {
                if (!form.value.takeaway) {
                  alert('请选择退料人');
                  return false;
                }
                if (!form.value.ordersn) {
                  alert('请选择辅料出库单')
                  return false;
                }
                if (!form.value.branch_id) {
                  alert('请选择成本承担部门')
                  return false;
                }
              }
            }
            if (form.value.parts.length == 0) {
              alert('请添加配件')
              return false;
            } else {
              for (const parts of form.value.parts) {
                if (parts.number <= 0) {
                  alert('请输入数量')
                  return false;
                }
              }
            }

          }
          else if (navindex.value == 2) {//出库
            if (form.value.type == 0) {
              if (!form.value.takeaway) {
                alert('请选择领料人');
                return false;
              }
              if (!form.value.car_name) {
                alert('请选择维修车辆')
                return false;
              }
              if (!form.value.branch_id) {
                alert('请选择成本承担部门')
                return false;
              }
            } else if (form.value.type == 1) {
              if (form.value.type == 1) {
                if (!form.value.takeaway) {
                  alert('请选择领料人');
                  return false;
                }
                if (!form.value.branch_id) {
                  alert('请选择成本承担部门')
                  return false;
                }
              }
            }
            if (form.value.parts.length == 0) {
              alert('请添加配件')
              return false;
            } else {
              for (const parts of form.value.parts) {
                if (parts.number <= 0) {
                  alert('请输入数量')
                  return false;
                }
              }
            }
          }
          else if (navindex.value == 3) {//采购入库
              let zeroNumber = 0;
              for (const parts of form.value.parts) {
                  const partsNumber = Number(parts.stock_number);
                  if (partsNumber != 0) {
                      if (partsNumber < 1 || !Number.isInteger(partsNumber)) {
                          alert('实际入库数量必须为大于等于1的整数')
                          return false;
                      }
                      if (partsNumber > parts.refundable_number) {
                          alert('超过待入库数量')
                          return false;
                      }
                  } else {
                      zeroNumber += 1;
                      if (zeroNumber == form.value.parts.length){
                          alert('请至少输入一项入库数量')
                          return false;
                      }
                  }
              }
              return true;
          }
          return true
        },
        _onsubmit = () => {
          if (!checkFormData()) {
            return;
          }
          is_load.value = true;
          let url = '';
          let myData = {};
          if (navindex.value == 1) {//出入库单新增
            myData = form.value;
            if (is_save.value) {
              url = 'adminapi/Warehouse/CreateWarehousing'
            } else {
              url = 'adminapi/Warehouse/CreateWarehousing'
            }
          } else if (navindex.value == 2) {//出入库单修改
            if (is_save.value) {//useRoute().query.uid
              url = 'adminapi/Warehouse/ChangeDelivery';
              myData = {...form.value, id:uid}
            } else {
              url = 'adminapi/Warehouse/CreateDelivery';
              myData = form.value;
            }
          } else if (navindex.value == 3) {//执行入库
            myData = form.value;
            url = 'adminapi/Warehouse/purchaseWarehousingEdit'
            
          }

          Request.axiosInstance({
            url: url,
            data: myData
          }).then((res: any) => {
            is_load.value = false
            res.status == 202 && Router.go(-1)
          })
        },
        _editlist_add = () => {
          if (navindex.value == 1)//入库单不能直接加配件
          {
            if (form.value.type == 0 && !form.value.car_name) {
              alert('请选择维修车辆')
              return
            }
            if (form.value.type == 1 && !form.value.ordersn) {
              alert('请选择辅料出库单')
              return
            }
          }


          dialog_show_.value = 'parts'

        },
        getSummaries = (param: any) => {
        },
        get_dialog_data = () => {

          dialog_isload.value = true
          if (dialog_show_.value == 'carcode') {
            Request.axiosInstance({
              url: 'adminapi/OrderCar/carcodeGetList',
              data: {car_code: dialog_search.value}
            }).then((res: any) => {
              dialog_isload.value = false
              dialog_data.value = res?.content?.list || []
            })
          } else {
            Request.axiosInstance({
              url: 'adminapi/Warehouse/libraryList',
              data: {type: 1, status: 1, search: dialog_search.value, library_type: '1'}
            }).then((res: any) => {
              dialog_isload.value = false
              dialog_data.value = res?.content?.list || []
            })
          }


        },
    
        getMountingInfo = (item:any)=>{
            for (const parts of form.value.parts) {
                if (parts.mountings_id == item.mountings_id) {
                    alert("您选择的配件已经在列表中了，请直接改数量");
                    return;
                }
            }
            form.value.parts.push({
                mountings_type_id: item.mountings_type_pid,
                mountings_id: item.mountings_id,
                name: item.name,
                specification: item.specification,
                mountings_type_pname: item.mountings_type_name,
                mountings_brand_name: item.mountings_brand_name,
                unit: item.mountings_unit_name,
                unit_price: item.price,
                number: '0'
            })
        },
        _table_select_carcode = (selection: any) => {
          if (!selection) return
          if (dialog_show_.value == 'carcode') {
            form.value['car_order_id'] = selection.id;
            form.value['car_name'] = selection.car_code;
            form.value['ordersn'] = selection.ordersn;
            //选完车牌之后要自动添加关联车辆报价配件供选择，去配件报价那里也就是orderoffer表拿，已出库和未出库的都显示出来，
              // 然后在去出入库记录表查询该订单已出库的配件
              getMountingsCheckOutInfo({order_id:selection.id}).then((res:any)=>{
                  if (res.status==200){
                      offer_data.value = [];
                      for (const item of selection.mountings_list) {
                          //const numInfo = res.content.list.find(v => v.mountings_id == item.mountings_id);
                          let totalInfo = {} as any;
                          for (const check of res.content.list) {
                              if (check.mountings_id ==item.mountings_id ){
                                  totalInfo = check;
                              }
                          }
                          let can_use = 0;
                          if (item.num<=totalInfo.number){
                              can_use = 1;
                          }
                        offer_data.value.push({
                            name:item.mountings.name,
                            mountings_id:item.mountings_id,
                            encoding:item.mountings.encoding,
                            specification:item.mountings.specification,
                            is_temporary:item.mountings.is_temporary,
                            mountings_type_pid:item.mountings.mountings_type_pid,
                            mountings_type_p_name:totalInfo.mountings_type_p_name,
                            mountings_brand_id:item.mountings.mountings_brand_id,
                            mountings_brand_name:totalInfo.mountings_brand_name,
                            unit_id:item.mountings.unit_id,
                            unit_name:totalInfo.mountings_unit_name,
                            quto_num:item.num,
                            use_num:0,
                            get_num:totalInfo.number,
                            return_number:0,
                            can_use:can_use,
                            price:item.mountings.selling_price
                        })
                      };
                  }
              });
              // getInfoOrderOffer({
              //     order_id: orderDetail.value.id,
              // }).then((res: any) => {
                  // if (res.status == 200) {
                  //     let list: Array<offerData[]> = [[], []];
                  //     res.content.list.forEach((item: offerData) => {
                  //         if (item.type == 1) {
                  //             list[0].push(item);
                  //         } else {
                  //             list[1].push(item);
                  //         }
                  //     });
                  //     if (list[0].length > 0) {
                  //         isProject.value = true;
                  //     }
                  //     if (list[1].length > 0) {
                  //         isMountings.value = true;
                  //     }
                  //     orderDetail.value.offer = list;
                  //     console.log(orderDetail.value)
                  // }
              //});
          } else if (dialog_show_.value == 'warehousing') {
            form.value['ordersn'] = selection.record_code
          }

          dialog_show_.value = ''
        },
        getdetail = (id: number) => {
          //门店ID【当为总店时必传】
          let userinfo;
          let user_info = localStorage.getItem('user_info');
          if (user_info) {
            userinfo = JSON.parse(user_info);
          }
          let data = {};
          if (userinfo.store_id == 0) {
            data = {
              store_id: 'store_id',
              id
            }
          } else {
            data = {
              id
            }
          }
          getLibraryInfo(data).then((res: any) => {
            if (res.status == 200) {
              form.value.branch_id = res.content.info.branch_id;
              form.value.takeaway = res.content.info.takeaway;
              form.value.desc = res.content.info.desc;
              form.value.type = res.content.info.type;
              form.value.parts = res.content.info.parts_list;
              form.value.car_order_id = res.content.info.car_order_id;
              form.value.ordersn = res.content.info.ordersn;
              if (navindex.value == 1 && form.value.type == '1') {
                form.value.ordersn = res.content.info.ordersn;
              } else {
                form.value.car_name = res.content.info.car_name;
              }
            }
          });
        },
        _defItem = (index: number) => {
          if (!confirm('是否确认操作？')) return
          form.value.parts.splice(index, 1)
        }


    watch(dialog_show_, (newdata: any, olddata: any) => {
      console.log(newdata)
      if (newdata == 'carcode' || newdata == 'warehousing') {
        dialog_search.value = "";
          nextTick(() => {
              inputref.value.focus();
          });
        get_dialog_data();
      } else if (newdata == 'parts') {
        getOrderCarMountings(dialogSelect.value).then((res: any) => {
          partsTable.value = res?.content?.mountings_data?.list || [];
          selectList.mountings_type_data = res?.content?.mountings_type || [];
          selectList.mountings_type_p_data = res?.content?.mountings_type_p || [];
        });
      }


    });

    onMounted(() => {

      let title = ''
      is_load.value = true

      type = useRoute().query.my_type
      if (type == '2') {
        title = "入库单";
        navindex.value = 1;
      } else if (type == '1') {
        title = "出库单";
        navindex.value = 2
      } else if (type == '3') {
        title = "采购入库";
        navindex.value = 3
      }
      setTitle(["仓库管理", title]);

      if (type == '3') {
        uid = useRoute().query.uid
        Request.axiosInstance({
          url: 'adminapi/Warehouse/purchaseWarehousingInfo',
          data: {purchase_id: uid}
        }).then((res: any) => {
          form.value = res?.content
          form.value['parts'] = res?.content.list
          for (let i = 0; i < form.value.parts.length; i++) {
            form.value.parts[i]['stock_number'] = 0
          }
          form.value.list = null;
          is_load.value = false;
        })
      } else {
        Request.axiosInstance({
          url: 'adminapi/OrderCar/constructors'
        }).then((res: any) => {
          selectList.staff = res?.content?.staff || []
          selectList.branch = res?.content?.branch || []
          is_load.value = false
        });
        let id: any = useRoute().query.uid;
        uid = useRoute().query.uid;
        if (id) {
          getdetail(id);
          is_save.value = true;
        }

      }


      //getOrderMountings()
    });


    return {
      navindex,
      dialog_show,
      dialogNavIndex,
      partsRules,
      partsForm,
      partsFormNode,
      partsTable,
      dialogSelect,
      serviceForm,
      selectList,
      headClass,
      is_all,
      handleSelectionChange,
      handleCurrentChange,
      partsColumn,
      dialogSelectChange,
      getOrderProject,
      getOrderCarProject,
      serviceDialog,
      orderDetail,
      selectData,
      serviceTable,
      form,
      PurchaseManList,
      supplierList,
      is_load,
      _onsubmit,
      formRef,
      formRules,
      _editlist_add,
      type,
      carcodeColumn,
      is_detail,
      detailColumn,
      getSummaries,
      detailData,
      dialog_isload,
      dialog_data,
      dialog_search,
      get_dialog_data,
      _table_select_carcode,
      dialog_show_,
      _defItem,
      coloumList,
        searchMountings,
        searchKeyWords,
        inputref,
        offer_data,
        getMountingInfo
    };
  },
});
